export default __webpack_public_path__ + "static/media/modal-bottom-white-wave.47ec5e6e.svg";